import { AbstractControl, ValidatorFn } from '@angular/forms';

// Custom Validator Function
export function nameExistsValidator(existingNames:string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let value = control.value;

    if(value){
      value = value.trim()
    }
    // Check if the value exists in the object
    const exists = Object.values(existingNames).includes(value);
    
    return exists ? { 'nameAlreadyTaken': { value } } : null;
  };
}
